module.exports = __webpack_public_path__ + "static/media/nd_hr.25221afe.png";